import en from './en.json'
import ar from './ar.json'
import de from './de.json'
import zh from './zh.json'
import ru from './ru.json'

const locales = {
  en,
  ar,
  de,
  zh,
  ru
}

export default locales
